/* eslint-disable */
import React, { useEffect, useMemo, useState } from "react";
import "./pickupCarInfoPopup.scss";
import Button from "@mui/material/Button";
import { withTranslation, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import Swal from "sweetalert2";
import {
  Chip,
  CircularProgress,
  IconButton,
  MenuItem,
  Stack,
  TextField,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import StandardBtn from "../StandardButton/StandardBtn";
import { getCookie } from "../../../../global-functions/cookieFunction";
import { get_lang } from "../../../../global-functions/apiGlobal";

const API_BASE = process.env.REACT_APP_API_URL;

const API_ROUTES = {
  add: `${API_BASE}/car/customer/add`,
  list: `${API_BASE}/car/customer/`,
  update: `${API_BASE}/car/customer/update/`,
  delete: `${API_BASE}/car/customer/delete/`,
  setDefault: `${API_BASE}/car/customer/default/`,
  companies: `${API_BASE}/car_company`,
};

const normalizeCompany = (company, lang) => {
  if (!company) {
    return null;
  }
  // const name =
  //   typeof company.name === "object"
  //     ? get_lang(company.name, lang)
  //     : company.name || "";

  return {
    id: company.id ?? company._id ?? null,
    name: company.name || company.title || company.name || "",
  };
};

const normalizeCarRecord = (car) => {
  if (!car) {
    return null;
  }


  return {
    id: car.id,
    isDefault: car.default || false,
    title: car.title || "",
    carCompanyName: car.car_company_name || car.company_name || "",
    carModel: car.car_name || "",
    carPlate: car.plate_no ||"",
    carColor: car.car_color || car.color || "",
    carCompanyId: car.car_company_id || car.company_id || null,
  };
};

const PickupCarInfoPopup = ({
  open,
  values,
  onChange,
  onCancel,
  onSave,
  onClose,
  pickupOptionDraft,
  data,
  orderPickupOption,
  setOrderPickupOption,
  setPickupOptionDraft,
  handlePickupOptionSelect,
  pickupDrivingDetails,
}) => {
  const { t } = useTranslation();
  const appState = useSelector((state) => state);
  const appDispatch = useDispatch();
  const token = getCookie("tokenAuth");
  const authHeaders = token
    ? {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    : null;


  const [companies, setCompanies] = useState([]);
  const [companiesLoading, setCompaniesLoading] = useState(false);
  const [savedCars, setSavedCars] = useState([]);
  const [savedCarsLoading, setSavedCarsLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [actionCarId, setActionCarId] = useState(null);
  const [defaultingCarId, setDefaultingCarId] = useState(null);
  const [selectedCarId, setSelectedCarId] = useState(values?.carId || null);
  const [apiError, setApiError] = useState("");
  const [showForm, setShowForm] = useState(false); // Track if form should be shown (for logged-in users)

  const fetchCompanies = async () => {
    setCompaniesLoading(true);
    try {
      const { data } = await axios.get(API_ROUTES.companies);
      console.log(data, "data");
      const companiesData = data?.data || data || [];
      if(companiesData.length > 0 ){
        const formattedCompanies = companiesData.map(company => ({
          id: company.id,
          name: company.name,
        }));
        setCompanies(formattedCompanies);
        console.log(formattedCompanies, "companies");
      }
    } catch (error) {
      handleRequestError(error, t("Unable to load car companies."));
    } finally {
      setCompaniesLoading(false);
    }
  };
  useEffect(() => {
    if (!open) {
      setShowForm(false); // Reset form view when popup closes
      return;
    }
    setSelectedCarId(values?.carId || null);
    // If user is not logged in, show form immediately
    // If logged in, show saved cars first (unless explicitly showing form)
    if (!appState?.loggedIn) {
      setShowForm(true);
    } else {
      // If logged in and no saved cars, show form immediately
      if (savedCars.length === 0 && !savedCarsLoading) {
        setShowForm(true);
      } else {
        setShowForm(false);
      }
    }
  }, [open, values?.carId, appState?.loggedIn, savedCars.length, savedCarsLoading]);
  const fetchSavedCars = async () => {
    if (!authHeaders) {
      return;
    }
    setSavedCarsLoading(true);
    try {
      const { data } = await axios.get(API_ROUTES.list, {
        headers: authHeaders,
      });
      const payload = data?.data || data || [];
      const normalized = payload
        .map((car) => normalizeCarRecord(car))
        .filter(Boolean);
      setSavedCars(normalized);
      console.log(payload, "payload");
      console.log(normalized, "normalized");  
      // If no saved cars and user is logged in, show form
      if (normalized.length === 0 && appState?.loggedIn) {
        setShowForm(true);
      }
    }
    catch (error) {
      handleRequestError(error, t("Unable to load saved cars."));
    } finally {
      setSavedCarsLoading(false);
    }
  }
  useEffect(() => {
    if (!open) {
      return;
    }
    fetchCompanies();
    if(appState?.loggedIn){
      fetchSavedCars();
    }

  }, [open, appState?.loggedIn]);

  const handleRequestError = (error, fallbackMessage, msgType) => {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      fallbackMessage ||
      t("Something went wrong, please try again.");
    appDispatch({
      type: "SHOW_ALERT",
      alertType: msgType || "error",
      message,
    });
  };



  // const fetchSavedCars = async () => {
  //   if (!authHeaders) {
  //     return;
  //   }
  //   setSavedCarsLoading(true);
  //   try {
  //     const { data } = await axios.get(API_ROUTES.list, {
  //       headers: authHeaders,
  //     });
  //     const payload = data?.data || data || [];
  //     const normalized = payload
  //       .map((car) => normalizeCarRecord(car))
  //       .filter(Boolean);
  //     setSavedCars(normalized);
  //   } catch (error) {
  //     handleRequestError(error, t("Unable to load your saved cars."));
  //   } finally {
  //     setSavedCarsLoading(false);
  //   }
  // };


  const serviceBtns = [{
    id: 1,
    show: appState.storeInfo.pickupOptions.includes('driven-thru'),
    type: 'driven-thru',
    name: "Driven Thru"
  },
  { id: 2,
    show: appState.storeInfo.pickupOptions.includes('car-service'),
    type: 'car-service',
    name: 'Car Service'
  },
  { id: 3,
    show: false,
    type: 'walk-in',
    name: 'Walk In'
  }
]

  const clearForm = () => {
    ["carMake", "carModel", "carColor", "carPlate", "parkingNotes"].forEach(
      (field) => onChange(field, "")
    );
    onChange("carCompanyId", null);
    onChange("carId", null);
  };

  const handleAddNewCar = () => {
    setSelectedCarId(null);
    setApiError("");
    clearForm();
    setShowForm(true); // Show form when adding new car
  };

  const handleCancelForm = () => {
    setShowForm(false);
    setSelectedCarId(null);
    setApiError("");
    clearForm();
  };

  const handleLoginClick = () => {
    appDispatch({ type: "setLoginModal", loginModal: true });
    onClose(); // Close car info popup to show login modal
  };

  const applyCarValues = (car) => {
    onChange("title", car.title || "");
    onChange("carModel", car.carModel || car.model || "");
    onChange("carColor", car.carColor || car.color || "");
    onChange("carPlate", car.carPlate || car.plate || "");
    onChange("parkingNotes", car.parkingNotes || car.notes || "");
    onChange("carCompanyId", car.carCompanyId || car.companyId || null);
    onChange("carCompanyName", car.carCompanyName || "");
    onChange("carId", car.id || null);
  };

  const handleEditCar = (car) => {
    setSelectedCarId(car.id);
    setApiError("");
    applyCarValues(car);
    setShowForm(true); // Show form when editing
  };

  const handleSelectCar = (car) => {
    // Toggle selection - if already selected, unselect it
    if (selectedCarId === car.id) {
      setSelectedCarId(null);
    } else {
      setSelectedCarId(car.id);
    }
    // Don't apply values immediately, wait for Apply button
  };

  const handleApplySelectedCar = () => {
    if (selectedCarId) {
      const selectedCar = savedCars.find(car => car.id === selectedCarId);
      console.log(selectedCar, "selectedCar");
      if (selectedCar) {
        // Preserve the type from values or previous state, default to car-service if not set
        const pickupType = values?.type || orderPickupOption?.type || 'car-service';
        
        const carData = {
          ...orderPickupOption,
          carId: selectedCar.id,
          carCompanyId: selectedCar.carCompanyId,
          carCompanyName: selectedCar.carCompanyName,
          carModel: selectedCar.carModel,
          carColor: selectedCar.carColor,
          carPlate: selectedCar.carPlate,
          type: pickupType,
        };
        
        // Update both orderPickupOption and pickupOptionDraft
        setOrderPickupOption(carData);
        if (setPickupOptionDraft) {
          setPickupOptionDraft(carData);
        }
        onSave();
      }
    }
  };



  const handleUseCar = async (car) => {
    const carData = {
      ...pickupOptionDraft,
      carId:pickupOptionDraft.carId,
      carCompanyId: pickupOptionDraft.carCompanyId,
      carCompanyName: pickupOptionDraft.carCompanyName,
      carModel: pickupOptionDraft.carModel,
      carColor: pickupOptionDraft.carColor,
      carPlate: pickupOptionDraft.carPlate,
      type: pickupOptionDraft.type,
    };

    let reqFields = [
      { name: "Car Plate No", value: values?.carPlate },
      { name: "Title", value: values?.title },
    ];
    const missing = reqFields.find((item) => !item.value);
    if (missing) {
      handleRequestError(null, t("Please fill all the required fields."), "error");
      return;
    }
    // Update both orderPickupOption and pickupOptionDraft
    setOrderPickupOption(carData);
    if (pickupOptionDraft) {
      setPickupOptionDraft(carData);
    }
    
    onSave(); // This will close the popup and use the selected car
  };

  const handleDeleteCar = async (carId) => {
        // const result = await Swal.fire({
        //   title: t("Are you sure?"),
        //   text: t("Do you want to delete this car?"),
        //   icon: "warning",
        //   showCancelButton: true,
        //   confirmButtonColor: "#dc3545",
        //   cancelButtonColor: "#6c757d",
        //   confirmButtonText: t("Yes, delete it!"),
        //   cancelButtonText: t("Cancel"),
        //   reverseButtons: appState?.langValue === "ar",
        //   customClass: {
        //     zIndex: '999999',
        //   },
        // });

        // if (!result.isConfirmed) {
        //   return;
        // }

    setActionCarId(carId);
    try {
      // If logged in, call API to delete
      if (appState?.loggedIn && authHeaders) {
        await axios.post(`${API_ROUTES.delete}${carId}`,{}, {
          headers: authHeaders,
        });
      }
      // Remove from local state
      setSavedCars((prev) => prev.filter((car) => car.id !== carId));
      if (selectedCarId === carId) {
        setSelectedCarId(null);
        clearForm();
      }
      
      handleRequestError(null, t("Car deleted successfully."), "success");
      // // Show success message
      // Swal.fire({
      //   title: t("Deleted!"),
      //   text: t("Car deleted successfully."),
      //   icon: "success",
      //   confirmButtonColor: "#28a745",
      //   timer: 2000,
      //   showConfirmButton: false,
      // });
    } catch (error) {
      handleRequestError(error, t("Unable to delete car."));
    } finally {
      setActionCarId(null);
    }
  };

  const handleSetDefaultCar = async (carId) => {
    setDefaultingCarId(carId);
    try {
      // If logged in, call API to set default
      if (appState?.loggedIn && authHeaders) {
        await axios.post(
          `${API_ROUTES.setDefault}${carId}`,
          {},
          {
            headers: authHeaders,
          }
        );
      }
      // Update local state
      setSavedCars((prev) =>
        prev.map((car) => ({
          ...car,
          isDefault: car.id === carId,
        }))
      );
    } catch (error) {
      handleRequestError(error, t("Unable to set default car."));
    } finally {
      setDefaultingCarId(null);
    }
  };

  
  const buildCarPayload = () => ({
    title: values?.title || "",
    car_company_id: values?.carCompanyId || null,
    company_name: values?.carCompanyName || null,
    car_name: values?.carModel || null,
    car_color: values?.carColor || null,
    plate_no: values?.carPlate || null,
    customer_id: appState?.userInfo?.customerId || null,
  });
  
  let reqFields = [
    { name: "Title", value: values?.title },
    // { name: "Car Company", value: values?.carCompanyId },
    // { name: "Car Model", value: values?.carModel },
    // { name: "Car Color", value: values?.carColor },
    { name: "Car Plate No", value: values?.carPlate },
    { name: "Login Customer", value: appState?.userInfo?.customerId },
  ];
  
  const handleSubmitCar = async () => {
    setApiError("");
    setSubmitting(true);
  
    const missing = reqFields.find((item) => !item.value);
  
    if (missing) {
      setApiError(t(`${missing.name} is required.`));
      setSubmitting(false);
      return;
    }
  
    if (appState?.loggedIn) {
      try {
        const payload = buildCarPayload();
        let data;
        
        if (selectedCarId) {
          // Update existing car
          const response = await axios.post(`${API_ROUTES.update}${selectedCarId}`, payload, {
            headers: authHeaders,
          });
          data = response.data;
        } else {
          // Add new car
          const response = await axios.post(API_ROUTES.add, payload, {
            headers: authHeaders,
          });
          data = response.data;
        }
        
        if(data?.success){
          handleRequestError(null, data?.message || t("Car saved successfully."), "success");
          await fetchSavedCars(); // Refresh saved cars list
          // If this was a new car, go back to saved cars view
          // If editing, stay in form view and select the car
          if (!selectedCarId) {
            setShowForm(false); // Go back to saved cars view for new cars
            clearForm();
            setSelectedCarId(null);
          } else {
            // For edited cars, update the selected car ID if needed
            const savedCar = data?.data ? normalizeCarRecord(data.data) : null;
            if (savedCar) {
              setSelectedCarId(savedCar.id);
              applyCarValues(savedCar);
            }
          }
        } else {
          handleRequestError(data?.error, t("Unable to save car."), "error");
        }
      } catch (error) {
        handleRequestError(error, t("Unable to save car."), "error");
      } finally {
        setSubmitting(false);
      }
    } else {
      // For non-logged-in users, just save locally and close
      onSave();
      setSubmitting(false);
    }
  };
  

  const handleCompanyChange = (event) => {
    const companyId = event.target.value || null;
    onChange("carCompanyId", companyId);
    const company = companies.find(
      (item) => `${item.id}` === `${companyId}`
    );
    if (company) {
      onChange("carCompanyName", company.name);
    }
  };

  const selectedCompany = companies.find(
    (company) => `${company.id}` === `${values?.carCompanyId || ""}`
  );
  const companyModels = selectedCompany?.cars || [];

  if (!open) {
    return null;
  }

  return (
    <div
      id="mySidenav"
      className={`pickupCarInfoPopup ${
        appState.langValue === "ar" ? "divideBillArabic" : " "
      }`}
    >
      <div className="container-fluid content px-4 pb-3 mt-4">
        <h1
          className={`pickupCarInfoPopup__header d-flex align-items-center justify-content-between ${
            appState.langValue === "ar"
              ? " familyGraphikArabic800 "
              : " familyPoppins300"
          }`}
        >
          {t("Car information")}
          <span
            className={`${
              appState.langValue === "ar" ? "mr-auto" : "ml-auto"
            }`}
          >
            {/* <IconButton onClick={onCancel}>
              <CloseIcon />
            </IconButton> */}
          </span>
        </h1>
        <hr />
            <div className="d-flex align-items-center justify-content-evenly w-100  "> 
              { serviceBtns.map((item, ind) => {
                if(!item.show) return null;
                return (
                  <Button
                  key={ind}
                  variant="contained"
                  className={`${
                    values?.type == item?.type 
                      ? "active-btn"
                      : "non-active-btn"
                  } p-2 mb-2 btn-padding`}
                  startIcon={item.icon}
                  onClick={() => handlePickupOptionSelect(item.type)}
                >
                  <span
                    className={`${
                      appState?.langValue == "ar" ? "px-2" : ""
                    }`}
                  >
                    {" "}
                    {t(`${item.name}`)}{" "}
                  </span>
                </Button>
                //   <StandardBtn
                //   key={item?.id}
                //   label={t(item.name)}
                //   handleCheckout={() => {
                //     handlePickupOptionSelect(item?.type);
                //   }}
                //   type="text-btn"
                //   disabled = {values?.type == item?.type}
                //   requiredClass= {`w-100  ${values?.type == item?.type ? `payBtn` : `transparentBtn`}`}
                //   sectionClass={`w-100 `}
                // />
                )
              })   }
              </div>
        
        {/* Show walk-in message if walk-in is selected */}
        {values?.type === 'walk-in' && (
          <div className="walkInMessage mt-4 mb-4">
            <div className="d-flex flex-column align-items-center justify-content-center py-5 px-3" style={{
              backgroundColor: '#f0f8ff',
              borderRadius: '12px',
              border: '2px solid #007bff',
              textAlign: 'center'
            }}>
              <div style={{ 
                fontSize: '48px', 
                marginBottom: '16px',
                color: '#007bff'
              }}>
                🚶
              </div>
              <h3 style={{ 
                fontSize: '20px', 
                fontWeight: '600', 
                color: '#333',
                marginBottom: '12px'
              }}>
                {t("Walk In")}
              </h3>
              <p style={{ 
                fontSize: '14px', 
                color: '#666',
                margin: '0',
                lineHeight: '1.6',
                maxWidth: '400px'
              }}>
                {t("You have selected walk-in pickup. Just come to our store to collect your order. No car information needed.")}
              </p>
            </div>
          </div>
        )}

        {/* Logged-in users: Show saved cars first, then form when needed - only if not walk-in */}
        {values?.type !== 'walk-in' && appState?.loggedIn && !showForm && (
          <div className="savedCarsPanel mt-3">
            <div className="savedCarsPanel__header d-flex justify-content-between align-items-center mb-3">
              <h2 className="mb-0" style={{ fontSize: '16px', fontWeight: '600', }}>
                {t("Saved cars")}
              </h2>
            </div>
            {savedCarsLoading ? (
              <div className="savedCarsPanel__loader d-flex justify-content-center py-4">
                <CircularProgress size={24} />
              </div>
            ) : savedCars.length > 0 ? (
              <div className="savedCarsList" style={{ marginBottom: '40px' }}>
                {savedCars.map((car) => (
                  <div
                    key={car.id}
                    className={`savedCarCard ${selectedCarId === car.id ? "savedCarCard--active" : ""}`}
                    style={{
                      transition: 'all 0.3s ease',
                      marginBottom: '8px',
                      padding: '12px 16px',
                      borderRadius: '8px',
                      border: selectedCarId === car.id ? '2px solid #007bff' : '1px solid #e0e0e0',
                      backgroundColor: selectedCarId === car.id ? '#f0f8ff' : '#fff',
                      boxShadow: selectedCarId === car.id ? '0 2px 8px rgba(0,123,255,0.15)' : '0 1px 3px rgba(0,0,0,0.1)',
                      position: 'relative'
                    }}
                  >
                    <div className="d-flex align-items-center gap-2">
                         {/* Bottom Right: Radio Checkbox */}
                         <div
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelectCar(car);
                          }}
                          style={{
                            marginTop: '8px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          {selectedCarId === car.id ? (
                            <RadioButtonCheckedIcon 
                              style={{ 
                                color: '#007bff',
                                fontSize: '24px'
                              }} 
                            />
                          ) : (
                            <RadioButtonUncheckedIcon 
                              style={{ 
                                color: '#ccc',
                                fontSize: '24px'
                              }} 
                            />
                          )}
                        </div>
                       </div>
                    <div className="d-flex align-items-start justify-content-between w-100">
                      {/* Car Info */}
                      <div style={{ flex: 1, minWidth: 0, paddingRight: '12px' }} className="mx-2">
                        {/* Title Row */}
                        <div className="d-flex align-items-center gap-2 mb-2">
                          <span style={{ 
                            fontWeight: '600', 
                            fontSize: '14px',
                            color: '#333',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap'
                          }}>
                            {car.title || t("Car")}
                          </span>
                          {/* {car.isDefault && (
                            <Chip 
                              label={t("Default")} 
                              size="small" 
                              style={{ 
                                height: '18px', 
                                fontSize: '10px',
                                backgroundColor: '#28a745',
                                color: '#fff',
                                marginLeft: '10px',
                                marginRight: '10px',
                              }} 
                            />
                          )} */}
                        </div>
                        
                        {/* Car Company */}
                        {car.carCompanyName && (
                          <div className="mb-1" style={{ fontSize: '12px' }}>
                            <span style={{ color: '#999', marginRight: '6px' }}>{t("Car Company")}:</span>
                            <span style={{ color: '#666', fontWeight: '500' }}>{car.carCompanyName}</span>
                          </div>
                        )}
                        
                        {/* Model */}
                        {car.carModel && (
                          <div className="mb-1" style={{ fontSize: '12px' }}>
                            <span style={{ color: '#999', marginRight: '6px' }}>{t("Model")}:</span>
                            <span style={{ color: '#666', fontWeight: '500' }}>{car.carModel}</span>
                          </div>
                        )}
                        
                        {/* Color */}
                        {car.carColor && (
                          <div className="mb-1" style={{ fontSize: '12px' }}>
                            <span style={{ color: '#999', marginRight: '6px' }}>{t("Color")}:</span>
                            <span style={{ color: '#666', fontWeight: '500' }}>{car.carColor}</span>
                          </div>
                        )}
                        
                        {/* Number Plate */}
                        {car.carPlate && (
                          <div className="mb-1" style={{ fontSize: '12px' }}>
                            <span style={{ color: '#999', marginRight: '6px' }}>{t("Number Plate")}:</span>
                            <span style={{ color: '#666', fontWeight: '500' }}>{car.carPlate}</span>
                          </div>
                        )}
                      </div>
                      
                      {/* Right Side Container */}
                      <div className="d-flex flex-column align-items-end justify-content-between" style={{ minHeight: '60px', marginBottom:'30px' }}>
                        {/* Top Right: Edit and Delete Buttons */}
                        <div className="savedCarCard__actions d-flex gap-1" onClick={(e) => e.stopPropagation()}>
                          <IconButton
                            size="small"
                            aria-label={t("Edit")}
                            onClick={() => handleEditCar(car)}
                            style={{ 
                              color: '#28a745',
                              padding: '4px'
                            }}
                            title={t("Edit")}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            size="small"
                            aria-label={t("Delete")}
                            disabled={actionCarId === car.id}
                            onClick={() => handleDeleteCar(car.id)}
                            style={{ 
                              color: '#dc3545',
                              padding: '4px'
                            }}
                            title={t("Delete")}
                          >
                            {actionCarId === car.id ? (
                              <CircularProgress size={16} />
                            ) : (
                              <DeleteOutlineIcon fontSize="small" />
                            )}
                          </IconButton>
                        </div>
                        
                        
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-4" style={{ color: '#999' }}>
                <p style={{ fontSize: '14px', marginBottom: '8px' }}>
                  {t("No saved cars yet.")}
                </p>
                <p style={{ fontSize: '13px' }}>
                  {t("Add your first car below to save it for future use.")}
                </p>
              </div>
            )}
          </div>
        )}

        {/* Form section - shown when user is not logged in OR when logged-in user clicks "Add more cars" - only if not walk-in */}
        {values?.type !== 'walk-in' && (!appState?.loggedIn || showForm) && (

          <div className="carFormSection my-4">
            {appState?.loggedIn && showForm && (
              <div className="mb-3 d-flex justify-content-between align-items-center">
                <h2 className="mb-0" style={{ fontSize: '16px', fontWeight: '600' }}>
                  {selectedCarId ? t("Edit car") : t("Add new car")}
                </h2>
              </div>
            )}
            {apiError && (
              <div className="alert alert-danger" style={{ fontSize: '13px', padding: '10px', borderRadius: '8px', marginBottom: '16px' }}>
                {apiError}
              </div>
            )}
            <Stack spacing={2} className={`${appState?.langValue == "ar" ? "classforArabicTextField" : ""}`}>
              <TextField
                label={t("Title")}
                name="title"
                value={values?.title || ""}
                onChange={(event) => onChange(event.target.name, event.target.value)}
                fullWidth
                variant="outlined"
                required
              />
               <TextField
                label={t("Plate number")}
                name="carPlate"
                value={values?.carPlate || ""}
                onChange={(event) => onChange(event.target.name, event.target.value)}
                fullWidth
                required
                variant="outlined"
              />
              <FormControl fullWidth>
                <InputLabel id="car-company-label">{t("Car company")}</InputLabel>
                <Select
                  labelId="car-company-label"
                  id="car-company-select"
                  value={values?.carCompanyId || ""}
                  label={t("Car company")}
                  onChange={handleCompanyChange}
                  disabled={companiesLoading}
                  MenuProps={{
                    style: { zIndex: 99999 },
                    disableScrollLock: true,
                  }}
                >
                  <MenuItem value="">
                    <em>{t("None")}</em>
                  </MenuItem>
                  {companies.map((company) => (
                    <MenuItem key={company.id} value={company.id}>
                      {company.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <TextField
                label={t("Car model")}
                name="carModel"
                value={values?.carModel || ""}
                onChange={(event) => onChange(event.target.name, event.target.value)}
                fullWidth
                variant="outlined"
              />
              
              <TextField
                label={t("Car color")}
                name="carColor"
                value={values?.carColor || ""}
                onChange={(event) => onChange(event.target.name, event.target.value)}
                fullWidth
                variant="outlined"
              />
             
            </Stack>
          </div>
        )}

        {/* Bottom buttons section */}
        <div className=" gap-2 mt-4 btn-fixed-class w-100" style={{ paddingBottom: '20px', zIndex: '1000' }}>



        {values?.type !== 'walk-in' && appState?.loggedIn && !showForm && savedCars.length > 0 && (
            <StandardBtn
              variant="contained"
              label={t("Next")}
              handleCheckout={handleApplySelectedCar}
              type="text-btn"
              requiredClass="w-100 payBtn"
              sectionClass="w-100"
              disabled={!selectedCarId}
            />
              
          )}

          {/* Walk-in: Show only continue/confirm button */}
          {values?.type === 'walk-in' && (
            <StandardBtn
              label={t("Continue")}
              handleCheckout={onSave}
              type="text-btn"
              requiredClass="w-100 payBtn"
              sectionClass="w-100"
            />
          )}

          {/* For logged-in users showing saved cars (and has saved cars) - only if not walk-in */}
          {values?.type !== 'walk-in' && appState?.loggedIn && !showForm && savedCars.length > 0 && (
                <StandardBtn
              label={t("Add more cars")}
              handleCheckout={handleAddNewCar}
              type="text-btn"
              requiredClass="w-100 transparentBtn"
              sectionClass="w-100 mt-2"
            />
           
          )}
          
       
          {/* For logged-in users showing form - only if not walk-in */}
          {values?.type !== 'walk-in' && appState?.loggedIn && showForm && (  
            <>
             <StandardBtn
              variant="contained"
              label={submitting ? t("Saving...") : t("Save")}
              handleCheckout={handleSubmitCar}
              type="text-btn"
              requiredClass="w-100 payBtn"
              sectionClass="w-100"
            />
              
              <StandardBtn
              label={t("Cancel")}
              handleCheckout={handleCancelForm}
              type="text-btn"
              requiredClass="w-100 transparentBtn mt-2" 
              sectionClass="w-100"
            />
           
            </>
          )}

          {/* For non-logged-in users - only if not walk-in */}
          {values?.type !== 'walk-in' && !appState?.loggedIn && (
            <>
            <StandardBtn
              label={t("Next")}
              handleCheckout={handleUseCar}
              type="text-btn"
              requiredClass="w-100 payBtn "
              sectionClass="w-100"
            />
              <StandardBtn
              label={t("Login to save cars")}
              handleCheckout={handleLoginClick}
              type="text-btn"
              requiredClass="w-100 transparentBtn mt-2"
              sectionClass="w-100"
            />
            
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(PickupCarInfoPopup);
